import Phaser from 'phaser'

export default class GameOverScene extends Phaser.Scene
{
    constructor()
    {
        super('game-over-scene')
    }

    preload()
    {
        this.load.image('replayBtn', 'images/replay_button2.png')

        this.load.image('gameOver','images/gameOver2.png')
    }

    create()
    {

        this.add.image(350, 230, 'gameOver').setScale(0.50)
        this.replayButton= this.add.image(350,450, 'replayBtn').setInteractive()

        this.replayButton.once('pointerup', () => { 
            this.scene.start('super-runnns-scene') 
        }, this)

    }
}